var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSlideLeftOrange = function SvgIconSlideLeftOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M7.138 4.138a.667.667 0 1 0-.943-.943L2.333 7.057c-.52.52-.52 1.365 0 1.886l3.862 3.862a.667.667 0 1 0 .943-.943L3.943 8.667h9.39a.667.667 0 1 0 0-1.334h-9.39l3.195-3.195Z"
  })));
};
export default SvgIconSlideLeftOrange;